export default "__VITE_ASSET__BRh7V1wq__"